'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryDebugMessage = function (_React$Component) {
  (0, _inherits3.default)(GalleryDebugMessage, _React$Component);

  function GalleryDebugMessage() {
    (0, _classCallCheck3.default)(this, GalleryDebugMessage);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryDebugMessage.__proto__ || (0, _getPrototypeOf2.default)(GalleryDebugMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryDebugMessage, [{
    key: 'render',
    value: function render() {
      if (_index2.default.getTopUrlParam('pgdebug') !== 'true') {
        return false;
      }

      var version = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        'Pro Gallery Version #',
        _windowWrapper2.default.staticsVersion
      );

      var parentSize = '';
      try {
        parentSize = ' psw' + _windowWrapper2.default.top.screen.width + ' piw' + _windowWrapper2.default.top.innerWidth + ' pbw' + _windowWrapper2.default.top.document.body.clientWidth;
      } catch (e) {
        //not on the domain
      }

      var debugMsg = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        _index2.default.isLandscape() ? 'land' : 'port',
        ' sw',
        _windowWrapper2.default.screen.width,
        'sh',
        _windowWrapper2.default.screen.height,
        ' iw',
        _windowWrapper2.default.innerWidth,
        ' bw',
        _windowWrapper2.default.document.body.clientWidth,
        ' sr',
        _index2.default.getViewportScaleRatio(),
        'rc',
        this.props.resizeCount,
        ' oc',
        this.props.orientationCount,
        ' nh',
        this.props.newHeight,
        ' lh',
        this.props.lastHeight,
        parentSize,
        'www',
        this.props.maxGalleryWidth
      );

      return _react2.default.createElement(
        'div',
        null,
        version,
        debugMsg
      );
    }
  }]);
  return GalleryDebugMessage;
}(_react2.default.Component);

exports.default = GalleryDebugMessage;